import { init as f, registerCallback as c } from "@bedrock-layout/register-resize-callback";
import { useStatefulRef as s } from "@bedrock-layout/use-stateful-ref";
import { useRef as i, useEffect as n } from "react";
function a(r, u) {
  const t = i(r), o = s();
  n(() => {
    t.current = r;
  });
  const e = o.current ?? u;
  return n(() => (f(), e ? c(e, t.current) : void 0), [e]), o;
}
export {
  a as useResizeObserver
};
